import { useEffect, useState } from "react";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { _ProductionOrder, _single } from "../../../core/services/dataBean/EntityCatalog";
import { toast } from "react-toastify";
import { Modal } from "../../theme/Component/Modal";
import { ProductionOrder } from "./ProductionOrder";

interface confProps {
    canEdit?: true;
    label?: string;
}

interface Props {
    IDOrderProduction: number;
    returnData: Function;
    _renderValue?: string;
    ConfigProps?: confProps;
}


export const ProductionOrderEditor = ({ IDOrderProduction, ConfigProps, returnData, _renderValue }: Props) => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_ProductionOrder);
    const [renderValue, setRenderValue] = useState<string>("");

    const [modal, setModal] = useState<any>({ name: "Información de la Necesidad", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-xl' });

    useEffect(() => {
        if (_renderValue) {
            setRenderValue(_renderValue)
        }
    }, [_renderValue])

    const returnDataBean = () => {
        if (bean.IDProductionOrder) {
            if (returnData) {
                returnData(bean);
                setModal({ ...modal, "view": false })
                setRenderValue(`${bean.IDProductionOrder} - ${bean.ProductionOrderDate}`)
            }
        } else {
            toast.error("Debe seleccionar una Orden de Producción valida");
        }
    }

    return (
        <>
            <label>{ConfigProps?.label ?? "Buscar Orden de Producción"}</label>
            <input className="form-control" aria-label="order production´s"
                aria-describedby="button-addon2" placeholder='Buscar...'
                value={renderValue}
                onClick={() => { setModal({ ...modal, 'view': true }); }}
            />

            <div className="col-md-12">
                <Modal modal={modal} updateModal={setModal} onSubmitLabel="Seleccionar Orden" eventModal={() => { returnDataBean() }} >
                    <div className="row">
                        <div className="col-md-12">
                            <ProductionOrder isModal onChange={setBean} />
                        </div>
                    </div>
                </Modal>
            </div>
        </>
    )
};